const title = "Audit log";

const entryDialog = {
	title: "Audit log entry",
};
const table = {
	export: { csv: "CSV exportieren" },
	headers: {
		created_at: "Erstellt am",
		debtor_code: "Schuldner-Code",
		entry: "Entry",
		event: "Event",
		ip_address: "IP-Adresse",
		username: "Username",
	},
};

const audit_log = {
	entry_dialog: entryDialog,
	table: table,
	title: title,
};

export default audit_log;
